<template>
    <div class="md-layout">
        <div class="md-layout-item md-small-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>user</md-icon>
                    </div>
                    <h4 class="title">Edit Employee</h4>
                </md-card-header>

                <form @submit.prevent="update">
                    <md-card-content>
                        <div class="text-right">
                            <md-button @click="goBack" class="md-primary md-dense">
                                Back to List
                            </md-button>
                        </div>
                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Vendor
                            </label>
                            <div class="md-layout-item">

                                <select-input
                                        v-model="employee.vendor_id"
                                        deselect-label="Can't remove this value"
                                        track-by="id"
                                        label=""
                                        placeholder="Select Institutions"
                                        :options="vendors"
                                        :allow-empty="false"
                                >
                                </select-input>
                                <validation-error :errors="apiValidationErrors.vendor_id" />
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                First Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="employee.first_name"/>
                                    <validation-error :errors="apiValidationErrors.first_name"/>
                                </md-field>
                            </div>
                        </div>    <div class="md-layout">
                        <label class="md-layout-item md-size-25 md-form-label">
                            Middle Name
                        </label>
                        <div class="md-layout-item">
                            <md-field class="md-invalid">
                                <md-input v-model="employee.middle_name"/>
                                <validation-error :errors="apiValidationErrors.middle_name"/>
                            </md-field>
                        </div>
                    </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Last Name
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="employee.last_name"/>
                                    <validation-error :errors="apiValidationErrors.last_name"/>
                                </md-field>
                            </div>
                        </div>
                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Check Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="employee.check_no"/>
                                    <validation-error :errors="apiValidationErrors.check_no"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout spacing">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Gender
                            </label>
                            <div class="md-layout-item">

                                <select-input
                                        v-model="employee.gender"
                                        deselect-label="Can't remove this value"
                                        track-by="name"
                                        label=""
                                        placeholder="Select  gender"
                                        :options="options"
                                        :allow-empty="false"
                                >
                                </select-input>
                                <validation-error :errors="apiValidationErrors.vedor_id" />
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Email
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="employee.email"/>
                                    <validation-error :errors="apiValidationErrors.email"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                Phone Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="employee.phone_number"/>
                                    <validation-error :errors="apiValidationErrors.phone_number"/>
                                </md-field>
                            </div>
                        </div>

                        <div class="md-layout">
                            <label class="md-layout-item md-size-25 md-form-label">
                                NIDA Number
                            </label>
                            <div class="md-layout-item">
                                <md-field class="md-invalid">
                                    <md-input v-model="employee.nida_number"/>
                                    <validation-error :errors="apiValidationErrors.nida_number"/>
                                </md-field>
                            </div>
                        </div>
                    </md-card-content>

                    <md-card-actions md-alignment="right">
                        <md-button type="submit" class="md-success">Update Employee</md-button>
                    </md-card-actions>
                </form>
            </md-card>
        </div>
    </div>
</template>

<script>
import SelectInput from '../../../components/Inputs/SelectInput';
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';

export default {
    components: { SelectInput,ValidationError },

    mixins: [formMixin],


    data () {
        return {
            employee: {
                type: 'employees ',
                first_name: null,
                middle_name: null,
                last_name: null,
                vendor_id:null,
                check_no: null,
                gender: null,
                email: null,
                phone_number: null,
                nida_number: null,
            },
            vendors: [],
            options: [
                { id: 'Female', 'name': 'Female' },
                { id: 'Male', 'name': 'Male' }
            ],


        };
    },

    created () {
        this.get();
        this. fetchInstitutions();
    },
    methods: {
        async get () {
            try {
                const id = this.$route.params.id;
                await this.$store.dispatch('employees/get', id);
                this.employee = this.$store.getters['employees/employee'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },

        async update () {
            try {
                await this.$store.dispatch('employees/update', this.employee);
                await this.$store.dispatch(
                    'alerts/success',
                    'Employee updated successfully.'
                );
                this.goBack();
            } catch (e) {
                if (e.response.data.errors[0]) {
                    await this.$store.dispatch(
                        'alerts/error',
                        e.response.data.errors[0].detail
                    );
                    this.setApiValidation(e.response.data.errors);
                } else {
                    await this.$store.dispatch(
                        'alerts/error',
                        'Oops, something went wrong!'
                    );
                }
            }
        },
        async fetchInstitutions () {
            await this.$store.dispatch('vendors/list');
            this.vendors = this.$store.getters['vendors/list'];
        },
        goBack () {
            this.$router.push({ name: 'Employees List' });
        },
    },
};
</script>
<style lang="scss" scoped>
    .spacing {
        padding-bottom: 1rem;
    }

    .md-inline-checkboxes {
        display: inline-flex;

    .md-checkbox {
        margin-top: 15px !important;
    }
    }

    .md-checkbox,
    .md-radio {
        margin-top: 15px;
        margin-bottom: 0.5rem;
    }

    .md-checkbox,
    .md-radio {
        display: flex;
    }

    .md-radio .md-radio-container {
        margin-left: 5px;
        position: relative;
        left: -3px;
    }

    .md-form-label + .md-layout-item .md-checkbox:not(:first-child),
    .md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
    .md-form-label + .md-layout-item .md-radio {
        margin-top: 0;
    }

    .md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
        padding-left: 0;
        padding-top: 10px;
        min-height: 150px;
    }

    .md-field:after,
    .md-field:before {
        bottom: 10px !important;
    }
</style>
<style >
    .ck-editor__editable {
        min-height: 200px;
        width: auto;
    }
</style>
